import { NavLink } from 'react-router-dom';
import teamImage from '../media/Grupo2.png';

/**
 * Bloque de presentación del home, con enlace a la página completa de Nosotros.
 */
const AboutSection = () => (
  <section className="aboutSection" id="about">
    <div className="aboutSectionImg">
      <img src={teamImage} alt="Equipo de Axioma Network en sesión de trabajo" />
    </div>

    <div className="aboutSectionText">
      <h3>Asesores en tecnologías de la información</h3>
      <p className="textBold">
        Abordamos las necesidades de tu empresa a través de áreas específicas para ofrecer una
        solución integral.
      </p>
      <p className="textContent">
        Somos una empresa de soluciones informáticas integrales: diseño web, servicios IT y
        marketing digital, trabajamos por y para las Pymes...
      </p>
      <NavLink to="/about" className="btnDark">
        Leer más
      </NavLink>
    </div>
  </section>
);

export default AboutSection;
